export default {
  registration: {
    header: {
      title: 'Trang đăng ký nhà cung cấp',
      // title_esg_data_share: '',
    },
    passcode: {
      section_one: 'Đây là trang đăng ký người dùng dành cho các công ty đã được yêu cầu sử dụng dịch vụ này.',
      section_two: 'Vui lòng nhập mã khóa để đến trang đăng ký.',
      section_three: 'Nếu không nhận được mã khóa, vui lòng liên hệ với công ty yêu cầu sử dụng dịch vụ này.',
      passcode: 'Mã khóa',
      passcode_placeholder: '@:common.form.search_word.placeholder',
      incomplete_input: 'Đầu vào không chính xác.',
      unexpected_error: 'Đã xảy ra lỗi không mong muốn',
    },
    email: {
      section_one: '@:registration.passcode.section_one',
      section_two: 'Vui lòng nhập địa chỉ email của bạn.',
      email: 'Địa chỉ email',
      email_placeholder: 'Điền địa chỉ email',
    },
    sent: {
      section_one: 'Email đã được gửi đến địa chỉ email bạn nhập.',
      section_two: 'Vui lòng kiểm tra URL trong email đó và tiến hành đăng ký tài khoản.',
      section_three: 'Nếu bạn không nhận được email trong vòng 30 phút, vui lòng liên hệ ',
      section_four: '',
    },
    password: {
      // TODO: section_one は日本語だと「アスエネ/アスエネESGの」を「アスエネ関連プロダクトの」に変更する対応が入っており、本言語にはそれが未反映
      section_one: 'Địa chỉ email bạn nhập đã được sử dụng cho tài khoản ASUENE/ASUENE ESG.',
      section_two: 'Vui lòng đăng nhập bằng mật khẩu của bạn.',
      password: 'Mật khẩu',
      // password_placeholder: '',
      error_auth: 'Xác thực không thành công. Vui lòng đăng nhập lại',
      // error_linking: '',
      // same_domain_modal: {
      //   title: '',
      //   section: '',
      // },
    },
    info: {
      section_one: '@:registration.passcode.section_one',
      section_two: 'Vui lòng nhập các thông tin cần thiết để hoàn tất việc đăng ký.',
      section_three: 'Vui lòng đăng nhập bằng tài khoản đã đăng ký sau khi đăng ký để có thể trả lời khảo sát mới.',
      buyer_name: 'Người mua',
      // expires_date: '',
      deadline: '@:common.date.answer_expires_date',
    },
    form: {
      invalid_form: '@:settings.messages.invalid_form',
      company_name: 'Tên Công ty',
      company_name_placeholder: '@:common.company_name_inc',
      company_scale: '@:settings.company.scale',
      select_placeholder: '@:upload_common.target_select',
      industry_type: '@:settings.company.industry_type',
      first_name: '@:settings.user.first_name',
      last_name_placeholder: 'Yamada',
      last_name: '@:settings.user.last_name',
      first_name_placeholder: 'Taro',
      email: '@:settings.user.email',
      email_placeholder: '@:settings.user.email',
      email_text: 'Địa chỉ email bạn nhập sẽ hiển thị',
      phone: 'Số điện thoại',
      phone_placeholder: '0000000000',
      locale: 'Chọn ngôn ngữ',
      section_one: 'Vui lòng đồng ý với các ',
      rule: 'Điều khoản và điều kiện',
      rule_link: '/pdf/241112_AsueneESG_Terms_and_Conditions_Supplier.pdf',
      punctuation: ' kiện cũng như ',
      policy: 'Chính sách quyền riêng tư ',
      policy_link: 'https://asuene.com/en/privacy',
      section_two: 'trước khi tiếp tục.',
      // same_domain_modal: {
      //   title: '',
      //   section: '',
      // },
    },
    thanks: {
      section_one: 'Cám ơn bạn đã đăng ký.',
      section_two: 'Chúng tôi đã gửi ID đăng nhập và mật khẩu của bạn đến địa chỉ email bạn đã nhập.',
      section_three: 'Vui lòng kiểm tra email của bạn và làm theo hướng dẫn trong email để đăng nhập.',
      section_four: 'Nếu bạn không nhận được email trong vòng 30 phút, vui lòng liên hệ ',
      section_five: '',
      section_six: 'Người phụ trách sẽ liên hệ với bạn',
    },
    expired: {
      section_one: 'URL được cung cấp đã hết hạn',
      section_two: 'Nếu muốn sử dụng dịch vụ này, vui lòng liên hệ theo địa chỉ ',
      section_three: 'Người phụ trách sẽ liên hệ với bạn.',
    },
    error: {
      section_one: 'Không tìm thấy URL được cung cấp.',
      section_two: 'Chúng tôi xin lỗi vì sự bất tiện này nhưng vui lòng kiểm tra lại URL.',
    },
    btn: {
      submit: 'Gửi',
      service_top: 'Đầu trang',
      login: 'Đăng nhập',
      register: 'Đăng ký',
      rating_url: 'https://asuene.com/rating/en',
    },
    buyer: {
      // sharing_company: "",
      // explain_message: "",
    },
  },
}
